function initFeaturedCollectionNc(root) {
  const grids = root.querySelectorAll('[data-fc-grid]');

  grids.forEach((grid) => {
    const cards = grid.querySelectorAll('[data-fc-card]');

    cards.forEach((card) => {
      const hoverImg = card.querySelector('.featured-collection-nc__image--hover');
      if (!hoverImg) return;

      // Force-load the hover image the first time the card is touched/hovered,
      // so mobile tap doesn't show a blank frame while it loads.
      const preload = () => {
        if (hoverImg.dataset.loaded === 'true') return;
        hoverImg.dataset.loaded = 'true';
        if (hoverImg.loading === 'lazy') {
          hoverImg.loading = 'eager';
        }
      };

      card.addEventListener('mouseenter', preload, { once: true });
      card.addEventListener('touchstart', preload, { once: true, passive: true });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initFeaturedCollectionNc(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initFeaturedCollectionNc(event.target);
});
